export var SeoLinksUseCaseEnum;
(function (SeoLinksUseCaseEnum) {
    SeoLinksUseCaseEnum["FOR_NEIGHBORS"] = "FOR_NEIGHBORS";
    SeoLinksUseCaseEnum["FOR_PLACE"] = "FOR_PLACE";
    SeoLinksUseCaseEnum["FOR_CHEAPEST_OR_MOST_EXPENSIVE"] = "FOR_CHEAPEST_OR_MOST_EXPENSIVE";
})(SeoLinksUseCaseEnum || (SeoLinksUseCaseEnum = {}));
